import { Locale } from '@ps-smart-cp/ppfw-client';

const leaseTransactionJudgeConfig = {
  useRightsLease: new Map([[Locale.ja, '使用権リース']]),
  smallSumAssetLease: new Map([[Locale.ja, '少額資産リース']]),
  shortLease: new Map([[Locale.ja, '短期リース']]),
};

export { leaseTransactionJudgeConfig };
